<template>
    <div class="row">
        <div class="col-sm-12">
            <h3>{{$t('components.news.title')}}</h3>
            <div class="row mt-3 mb-5">
                <div class="col-sm-12 col-md">
                    <button :class="['btn w-100', current === 'ACTIVE' ? 'btn-wellis-gold text-white' : 'btn-outline-wellis-gold']"
                            @click="fetch()">
                        {{$t('active') | toUpper}}
                    </button>
                </div>
                <div class="col-sm-12 col-md">
                    <button :class="['btn w-100', current === 'INACTIVE' ? 'btn-wellis-gold text-white' : 'btn-outline-wellis-gold']"
                            @click="fetch('INACTIVE')">
                        {{$t('inactive') | toUpper}}
                    </button>
                </div>
            </div>
            <router-link :to="{name: 'app.admin.news.create'}"
                         class="btn btn-sm btn-wos-real mb-4">{{$t('components.administration.news.btnCreate')}}
            </router-link>
            <table class="table table-hover table-striped">
                <thead>
                <tr>
                    <th></th>
                    <th>Id</th>
                    <th>{{$t('components.administration.news.title')}}</th>
                    <th>{{$t('components.administration.news.category')}}</th>
                    <th>{{$t('components.administration.category.slug')}}</th>
                    <th>{{$t('components.administration.news.author')}}</th>
                    <th>{{$t('components.administration.news.special')}}</th>
                    <th>{{$t('components.administration.category.news.restricted')}}</th>
                    <th>{{$t('components.administration.news.availableAt')}}</th>
                    <th>{{$t('components.administration.category.status')}}</th>
                    <th>{{$t('components.administration.failed-orders.createdAt')}}</th>
                    <th>{{$t('components.administration.failed-orders.updatedAt')}}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in items" :key="item.id">
                    <td>
                        <router-link class="btn btn-sm btn-wellis-black text-white"
                                     :to="{name: 'app.admin.news.edit', params: {id: item.id}}">
                            <i class="fa fa-eye"></i>
                        </router-link>
                    </td>
                    <td>#{{item.id}}</td>
                    <td>{{item.title | cut(20)}}</td>
                    <td class="text-center">{{item.category_name}}</td>
                    <td>/{{item.slug | cut(20)}}</td>
                    <td>{{item.author_name}}</td>
                    <td>{{item.special ? $t('confirm.yes') : $t('confirm.no')}}</td>
                    <td>{{item.restricted ? $t('confirm.yes') : $t('confirm.no')}}</td>
                    <td>
                        <span v-if="item.available_at">{{item.available_at | formatDate(true)}}</span>
                        <span v-else>-</span>
                    </td>
                    <td>{{$t(item.objstate.toString().toLowerCase()) | capitalize}}</td>
                    <td>{{item.created_at | formatDate(true)}}</td>
                    <td>{{item.updated_at | formatDate(true)}}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import NewsApiService from "@/api/news.api";

export default {
    name: "NewsOverview",

    created() {
        this.fetch();
    },

    data() {
        return {
            current: 'ACTIVE',
            items: []
        }
    },

    methods: {
        async fetch(objstate = 'ACTIVE') {
            return new Promise((resolve, reject) => {
                let loader = this.$loading.show();
                NewsApiService.get(objstate, false, true)
                    .then(response => {
                        this.items = response.data.items;
                        this.current = objstate;
                        resolve(response.data);
                    })
                    .catch(error => {
                        this.$swal.fire({
                            icon: "error",
                            allowOutsideClick: false,
                            html: this.$t('api-error')
                        });
                        reject(error);
                    })
                    .finally(() => {
                        loader.hide();
                        loader = null;
                    });
            });
        }
    }
}
</script>

<style scoped>

</style>
